/**
 * @generated SignedSource<<43d3d347d40978b961c08641c6a9a139>>
 * @relayHash c3ce615b05149767eb513076e257e941
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3ce615b05149767eb513076e257e941

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubscriptionSectionRefetchableFragmentQuery$variables = {
  id: string;
};
export type SubscriptionSectionRefetchableFragmentQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"SubscriptionSectionRefetchableFragment">;
  } | null | undefined;
};
export type SubscriptionSectionRefetchableFragmentQuery = {
  response: SubscriptionSectionRefetchableFragmentQuery$data;
  variables: SubscriptionSectionRefetchableFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionSectionRefetchableFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SubscriptionSectionRefetchableFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionSectionRefetchableFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerThreadSubscriptionFormAction",
                "storageKey": null
              }
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c3ce615b05149767eb513076e257e941",
    "metadata": {},
    "name": "SubscriptionSectionRefetchableFragmentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "503d86fd24a4cf3bea72e4a6aca5b17f";

export default node;
